import http from "./httpService";

const apiEndPoint = "/storemanagers/";

function getStoreManagers() {
  return http.get(apiEndPoint);
}

export default getStoreManagers;
